import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react"; // Import icon cho thất bại
import { postData } from "../../api/api"; // Điều chỉnh đường dẫn nếu cần thiết

export default function PaymentCancel() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Lấy các tham số query từ URL
    const searchParams = new URLSearchParams(location.search);
    const paymentId = searchParams.get("paymentId");
    console.log(paymentId);

    // Gửi request về server để xử lý thanh toán không thành công
    postData("/payments/payment-cancel", { paymentId: paymentId })
      .then((postResponse) => {
        console.log("POST /payments/payment-failure response:", postResponse);
      })
      .catch((postError) => {
        console.error("Error in POST /payments/payment-failure:", postError);
      });
  }, [location.search]);

  return (
    <div className="m-auto flex justify-center p-20 mb-40">
      <div className="bg-white rounded-lg shadow-xl w-auto p-6 text-center">
        {/* Biểu tượng thất bại (thay Check bằng XCircle) */}
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>

        {/* Tiêu đề và thông báo */}
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Payment Failed
        </h2>

        <p className="text-gray-600 mb-6">
          Something went wrong during the payment process. Please try again.
        </p>

        {/* Nút quay lại trang chủ */}
        <button
          onClick={() => navigate("/")}
          className="w-full py-2 px-4 bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors duration-200"
        >
          Go back to Home
        </button>
      </div>
    </div>
  );
}
